import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { ID } from '@datorama/akita';

import { CollectionTable } from '@component/collection-table';

export interface EntityCardAction {
  action: (item?: any) => void;
  dataTestId?: string;
  icon: string;
  label?: string;
  tooltip: string;
  value?: any;
}

export interface EntityCardMenuItem {
  action: (value: any) => void;
  label: string;
  value?: any;
}

export interface EntityCardMenu {
  items: EntityCardMenuItem[];
}

export interface EntityCardData {
  label: string;
  numeric?: boolean;
  tooltip?: string;
  value: string;
}

export interface EntityCardBadge {
  class?: string;
  icon?: string;
  label?: string;
  tooltip?: string;
}

export interface EntityCardPrimaryAction {
  action: (item?: any) => void;
  data?: any;
  disabled?: boolean;
  label: string;
}

export interface EntityCard {
  actions?: EntityCardAction[];
  active?: boolean;
  badges?: EntityCardBadge[];
  data?: EntityCardData[];
  disabled?: boolean;
  fullCpc?: boolean;
  id?: ID;
  image?: string;
  link?: string | (string | ID)[];
  menu?: EntityCardMenu;
  meta?: string;
  name: string;
  primaryAction?: EntityCardPrimaryAction;
  primaryBadge?: EntityCardBadge;
  shared?: boolean;
  shareable?: boolean;
  table?: CollectionTable;
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-entity-card',
  styleUrls: ['./entity-card.component.scss'],
  templateUrl: './entity-card.component.html'
})
export class EntityCardComponent implements OnInit {
  @Input() card: EntityCard;
  @Input() initiallyExpanded: boolean;
  @Input() showEllipsisMenu = true;
  @Input() fullCpc?: boolean;
  @Output() toggleExpand: EventEmitter<boolean> = new EventEmitter();

  expanded = false;

  @HostBinding('class.with-actions')
  get className(): boolean {
    return !!(this.card.actions || this.card.table);
  }

  @HostBinding('class.active')
  get activeClassName(): boolean {
    return this.card.active;
  }

  @HostBinding('class.disabled')
  get disabledStatus(): boolean {
    return this.card.disabled;
  }

  constructor() {}

  ngOnInit() {
    if (this.initiallyExpanded) this.expanded = true;
  }

  cardBackgroundImage(card: EntityCard): string {
    return `url(${card.image})`;
  }

  toggleExpansion(): void {
    this.expanded = !this.expanded;
    this.toggleExpand.emit(this.expanded);
  }
}
